
export default {
    CURR_USER_KEY : 'Wa-Us7FOrjJDuesq3oSt46w2',
    ID_CONGRESSO : 'CHeo102oVKzLbbbQ95DgJ4g222',
    URL_CERTIFICADO: 'dhw8RSNRCgKoLHjathyYbEA2',
    URL_COMPROVANTE: 'NTg3NA==45JN',
    URL_CRACHA: 'fl45lGpnwqYxy87J79CBLBA2'
} 


// WEBPACK FOOTER //
// ./src/Keys.js